import axios from 'axios'
import Vue from 'vue'

axios.defaults.baseURL = process.env.VUE_APP_BASE_API + 'api/v1'
axios.defaults.headers.common['Authorization'] =
  'Bearer ' + localStorage.getItem('access_token')
axios.interceptors.response.use(
  (response) => {
    // Show success message
    if (response.data && response.data.message && response.data.success) {
      Vue.$toast.open({
        message: response.data.message,
        type: 'success',
        duration: 5000,
      })
    }

    return response
  },
  (error) => {
    // error.response is UNDEFINED for network failures, timeouts, CORS rejections and
    // ad-blocked requests. Reading .status on it threw a TypeError from inside this
    // interceptor, and that TypeError became the rejection value -- so callers doing
    // `err.response.data` in their .catch threw again BEFORE resetting their loading
    // flag. The public paid-signup and redemption forms spun forever with no message.
    const response = error.response
    const status = response ? response.status : null

    if (!response) {
      Vue.$toast.open({
        message: 'Network error. Please check your connection and try again.',
        type: 'error',
        duration: 5000,
      })
      return Promise.reject(error)
    }

    if (status === 401 && localStorage.getItem('access_token')) {
      // The token is no longer usable -- expired, revoked, or a session minted
      // before the API enforced token scopes. Leaving it in localStorage makes
      // every later request fail silently (401 raises no toast), so the app looks
      // signed in while nothing loads. Clear it and send the user to sign in.
      //
      // Hard navigation rather than a router push: it also resets in-memory store
      // state, and this module cannot import the store or router without a
      // circular import (store modules import axios).
      localStorage.removeItem('access_token')
      localStorage.removeItem('main_access_token')
      localStorage.removeItem('main_access_role')
      delete axios.defaults.headers.common['Authorization']

      if (window.location.pathname !== '/login') {
        window.location.assign('/login')
      }

      return Promise.reject(error)
    }

    if (status === 422) {
      // A 422 body does not always carry `errors` -- Object.keys(undefined) threw here
      // and discarded the real validation message.
      const errors = response.data && response.data.errors
      const keys = errors ? Object.keys(errors) : []
      const message =
        keys.length && errors[keys[0]]
          ? errors[keys[0]][0]
          : (response.data && response.data.message) || ''
      if (message) {
        Vue.$toast.open({ message, type: 'error', duration: 5000 })
      }
    } else if (status !== 406) {
      if (response.data && response.data.message && !response.data.silent) {
        Vue.$toast.open({
          message: response.data.message,
          type: 'error',
          duration: 5000,
        })
      }
    }

    // ALWAYS reject, including on 401.
    //
    // The 401 branch used to be an empty `if` that fell through and returned undefined,
    // which RESOLVES the promise. Every caller's .then() ran as if the request had
    // succeeded: payment-method remove/setDefault, contact remove/bulkRemove,
    // business archive/delete/resetNumber and broadcast sentTest all reported success
    // and updated the UI while the server had done nothing. Deleting a card made the
    // row vanish locally while the card stayed on file.
    //
    // 401 stays silent (no toast) to avoid a toast storm when a whole page's requests
    // fail at once, but it must reject so callers can see the failure.
    return Promise.reject(error)
  }
)
